import { useMatomo } from '@datapunt/matomo-tracker-react';
import React from 'react';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as CloseSvg } from '@assets/svg/closx.svg';

import { useAppActions } from '@store/useAppStore';
import { useAppPersistActions } from '@store/useAppStorePersist';

import { selectMapTooltipContentStatic, useMapActions } from '../../store/useMapStore';
import MapMarkerSvg from '../MapMarkerSvg/MapMarkerSvg';
import style from './style.module.scss';

const MapTooltipStatic = ({ id }) => {
  const { trackEvent } = useMatomo();
  const { setAppPersistMapsVisible } = useAppPersistActions();
  const { setMapGeoState, setMapTooltipContentStatic } = useMapActions();
  const { setAppLocationSelectValue } = useAppActions();

  const markers = selectMapTooltipContentStatic();

  const handleLinkClick = (country, name, facility_info) => {
    trackEvent({ category: 'Map Usage', action: 'map-interaction ' });
    setMapGeoState({ type: 'country', name: country, facilityName: name });
    setMapTooltipContentStatic(null);
    setAppPersistMapsVisible(false);
    setAppLocationSelectValue(facility_info);
  };

  return (
    <Tooltip
      id={id}
      place="bottom"
      clickable
      openOnClick
      className={style.mapStaticTooltip}
      render={() => {
        if (!markers) {
          return null;
        }

        return (
          <div className={style.tooltipContainer}>
            <CloseSvg className={style.closeSvg} onClick={() => setMapTooltipContentStatic(null)} />
            {markers.map(({ facility_id, facility_info, country, name, mapMarker }) => (
              <div
                key={facility_id}
                className={style.facilityItem}
                onClick={() => handleLinkClick(country, name, facility_info)}
              >
                <MapMarkerSvg variant={mapMarker?.icon} color={mapMarker?.color} />
                {name}
              </div>
            ))}
          </div>
        );
      }}
    />
  );
};

export default MapTooltipStatic;
